import { Comments } from "./Comments";
import { LessonRatingCard } from "./LessonRatingCard";

export function LessonCommunityTab({ lessonId }: { lessonId: number }) {
  return (
    <div className="py-6">
      <LessonRatingCard lessonId={lessonId} />
      <Comments type="lesson" typeId={lessonId} />
    </div>
  );
}
